import type { HoldReason, PortalProduct } from "./types";

/**
 * TEMPORARY. Stand-ins for two settings core has no read endpoint for yet.
 * The values are copied from the seeds in core's migration 20261001b
 * (portal.products, review.hold_reasons), labels included, so a rep sees the
 * words the setting holds. If an admin changes a setting these go stale; when
 * the read endpoints exist, the two functions in ./index.ts call them and this
 * file is deleted.
 */
export const PORTAL_PRODUCTS: PortalProduct[] = [
  {
    slug: "travel-forex",
    label: "Travel forex",
    note: "Currency notes are quoted per order.",
  },
  { slug: "visa", label: "Visa services" },
];

export const HOLD_REASONS: HoldReason[] = [
  { code: "unreadable", label: "We could not read this file" },
  { code: "wrong_document", label: "This is not the document we asked for" },
  { code: "details_mismatch", label: "The details do not match" },
  { code: "expired", label: "This document is out of date" },
  { code: "incomplete", label: "Something is missing", needsDetail: true },
  { code: "other", label: "Something else", needsDetail: true },
];
